import {variant} from 'styled-system';
import styled from '@emotion/styled';
import DownloadIcon from "imagesUwKluis/svg/download.svg";
import {Flex} from '../../../../shared/layouts';
import PaperClipIcon from 'imagesUwKluis/svg/paperclip.svg';
import AddIcon from 'imagesUwKluis/svg/add.svg';
import ConfirmIcon from 'imagesUwKluis/svg/confirmed-filled.svg';
import AlertIcon from 'imagesUwKluis/svg/alertfill.svg';
import {FC} from "react";
import AlertMessageBanner from "../../../../shared/AlertMessageBanner";

const variants = {
  default: {
    borderBottom: '1px solid',
    borderBottomColor: 'border',
    bg: 'white',
    svg: {
      fill: 'black',
      '&.actionIcon': {
        fill: 'primary'
      }
    }
  },
  selected: {
    borderBottom: '2px solid',
    borderBottomColor: 'primary',
    bg: 'transparent',
    svg: {
      fill: 'primary',
      '&.actionIcon': {
        fill: 'primary'
      }
    }
  },
  shared: {
    ':first-of-type': { borderTop: 'default' },
    borderBottom: 'default',
    bg: 'secondaryBackground',
    svg: {
      fill: 'secondaryButtonActive',
    }
  },
  rejected: {
    borderBottom: '2px solid',
    borderBottomColor: 'alert',
    bg: 'secondaryBackground',
    svg: {
      fill: 'alert',
      '&.actionIcon': {
        fill: 'alert'
      }
    }
  }
};

interface StyledFileProps {
  variant: FileItemVariant;
}

const StyledFile = styled(Flex)<StyledFileProps>(({ theme }) => [
  {
    alignItems: 'center',
    height: '48px',
    padding: '12px',

    '&:hover': {
      backgroundColor: theme.colors.secondaryBackground
    },

    span: {
      display: 'block',
      padding: '0 12px',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      flexGrow: 1
    },

    svg: {
      display: 'block',
      height: 24,
      width: 24,
      flexShrink: 0
    }
  },
  variant({ prop: 'variant', variants })
]);

const ActionIcon = ({ variant, ...props }) => {
  switch (variant) {
    case 'default':
      return <AddIcon {...props} />;
    case 'selected':
    case 'shared':
      return <ConfirmIcon {...props} />;
    case 'rejected':
      return <AlertIcon {...props} />;
  }
};

export type FileItemVariant = 'default' | 'selected' | 'rejected' | 'shared';

interface FileItemsProps {
  name: string,
  onClick?: () => void,
  variant?: FileItemVariant;
  downloadUrl?: string;
  message?: string;
  severity?: 'error' | 'warning';
}

export const FileItem: FC<FileItemsProps> = ({ name, onClick, variant = 'default', downloadUrl = null, message = null, severity = null }) => (
  <>
    <StyledFile fontScale="m" variant={variant}>
      <PaperClipIcon />
      <span title={name}>{name}</span>

      {downloadUrl && (
        <a href={downloadUrl} download>
          <DownloadIcon
            width="1.5rem"
            height="1.5rem"
            css={(theme) => ({ fill: theme?.colors?.secondaryFont })}
          />
        </a>
      )}

      <ActionIcon
        variant={variant}
        className="actionIcon"
        onClick={onClick}
        css={{ cursor: onClick ? 'pointer' : null }}
      />
    </StyledFile>

    {message && (
      <AlertMessageBanner severity={severity}>
        {message}
      </AlertMessageBanner>
    )}
  </>
);

export default FileItem;
